export default __webpack_public_path__ + "static/media/photo--lg--36.13630462.jpg";